module.exports = __webpack_public_path__ + "static/media/dentistry.f68d7b19.svg";